export const ADD_SURVEY_WELCOME = "ADD_SURVEY_WELCOME"
export const EDIT_SURVEY_WELCOME= "EDIT_SURVEY_WELCOME"
export const LIST_SURVEY_WELCOME = "LIST_SURVEY_WELCOME"
export const VIEW_SURVEY_WELCOME = "VIEW_SURVEY_WELCOME"
export const DELETE_SURVEY_WELCOME = "DELETE_SURVEY_WELCOME"

export const SURVEY_WELCOME_SUCCESS = "SURVEY_WELCOME_SUCCESS"
export const SURVEY_WELCOME_ERROR = "SURVEY_WELCOME_ERROR"
